import { createSlice } from '@reduxjs/toolkit'

export const searchKeywordSlice = createSlice({
  name: 'searchKeyword',
  initialState: {
    value: ''
  },
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    }
  }
})

export const { update } = searchKeywordSlice.actions

export const searchKeyword = (state) => state.searchKeyword.value

export default searchKeywordSlice.reducer